import useDragScroll from "../lib/useDragScroll";

// Scroll container with click-and-drag panning. Drop-in replacement for a
// plain <div className="overflow-auto"> wrapper. A right-edge fade hints at
// horizontal overflow on narrow screens.
export default function DragScrollContainer({ children, ...rest }) {
  const ref = useDragScroll();
  return (
    <div className="relative">
      <div ref={ref} {...rest}>
        {children}
      </div>
      <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-white/90 to-transparent lg:hidden" />
    </div>
  );
}
